import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { actions } from 'builder/modules/resumeEditor'
import { BriefExpertDoc, BriefResume } from 'builder/modules/panel'

type ResumeTailoringActions = {
  showResumeSelect: boolean
  setShowResumeSelect: (show: boolean) => void
  handleCompletedClick: () => void
  onResumeTailoring: (resume: BriefResume | BriefExpertDoc) => void
}

export const useResumeTailoringActions = (): ResumeTailoringActions => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [showResumeSelect, setShowResumeSelect] = useState(false)

  const handleCompletedClick = () => {
    // TODO: Implement
  }

  const onResumeTailoring = (resume: BriefResume | BriefExpertDoc) => {
    navigate(`/resumes/${resume.id}/edit`)
    dispatch(actions.setOpenOptimizerModal(true))
  }

  return {
    showResumeSelect,
    setShowResumeSelect,
    handleCompletedClick,
    onResumeTailoring,
  }
}
